import Vue from 'vue'
import App from './App.vue'
//import router from './router/index'
//import './router/init-axios'

new Vue({
  //router,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js